<template>
	<!-- 考试倒计时 -->
	<div class="content" id="apps">
		<img class="bgiss" src="../assets/images/bgc1.png" alt=""/>
		<!-- TAB栏 -->
		<el-header>
			<div class="Left"></div>
			<div class="Right" @click="FAuni">
				<span class="iconfont">&#xe641;</span>
				<span class="iconHome">返回首页</span>
			</div>
		</el-header>
		<!-- 内容 -->
		<el-main>
			<p class="tips">您好！ {{username}}， 请选择考试内容</p>
			<el-button type="primary" @click="onTheory">理论考试</el-button>
			<div class="xiao">
				<div v-if="options.two.item.length>0" class="list_title">
					<p>{{options.two.title}}</p>
				</div>
				<div v-for="(item, index) in options.two.item" :key="index" class="imgss">
					<div v-if="duic2[index] && duic2[index].length == 1" @click="handleChange(item)">
						<img :src="require(`../static/img/${item.value}1.png`)" alt="" />
					</div>
					<div v-else @click="handleChange(item)">
						<img :src="require(`../static/img/${item.value}.png`)" alt="" />
					</div>
				</div>
				<div v-if="options.three.item.length>0" class="list_title">
					<p>{{options.three.title}}</p>
				</div>
				<div v-for="(item, index3) in options.three.item" :key="index3" class="imgss">
					<div v-if="duic3[index3] && duic3[index3].length == 1" @click="handleChange(item)">
						<img :src="require(`../static/img/${item.value}1.png`)" alt="" />
					</div>
					<div v-else @click="handleChange(item)">
						<img :src="require(`../static/img/${item.value}.png`)" alt="">
					</div>
				</div>
				<div v-if="options.four.item.length>0" class="list_title">
					<p>{{options.four.title}}</p>
				</div>
				<div v-for="(item, index4) in options.four.item" :key="index4" class="imgss">
					<div v-if="duic4[index4] && duic4[index4].length == 1" @click="handleChange(item)">
						<img :src="require(`../static/img/${item.value}1.png`)" alt="" />
					</div>
					<div v-else @click="handleChange(item)">
						<img :src="require(`../static/img/${item.value}.png`)" alt="" />
					</div>
				</div>
			</div>
		</el-main>

	</div>

</template>

<script>
	export default {
		data() {
			return {
				username: '',
				number: 0,
				curriculum: [],
				values: '',
				options: {
					two: {
						title: '二楼',
						item: []
					},
					three: {
						title: '三楼',
						item: []
					},
					four: {
						title: '四楼',
						item: []
					}
				},
				fraction: [],
				duic: [],
				duic2: [],
				duic3: [],
				duic4: []				
			}
		},
		created(option) {
			this.receive()
			this.qwe()
			this.xfu()
		},
		methods: {
			onTheory() {
				this.$router.push({
					path: "/theory",
					query: {
						number: this.number
					}
				});
			},
			async qwe() {
				const {
					data: res
				} = await this.$http.get(
					`fractionFS/${this.number}`
				);
				console.log('qwe-res', res);
				for (const key in res) {
					if (res[key].fraction) {
						this.fraction.push(res[key].fraction)
					}
				}
				for (let index = 0; index < this.options.two.item.length; index++) {
					const qwe2 = this.RQfSearch(this.options.two.item[index].label)
					this.duic2.push(qwe2)
				}
				for (let index = 0; index < this.options.three.item.length; index++) {
					const qwe3 = this.RQfSearch(this.options.three.item[index].label)
					this.duic3.push(qwe3)
				}
				for (let index = 0; index < this.options.four.item.length; index++) {
					const qwe4 = this.RQfSearch(this.options.four.item[index].label)
					this.duic4.push(qwe4)
				}
				console.log('this.duic2, this.duic3, this.duic4,', this.duic2, this.duic3, this.duic4);
				// console.log('this.options.three.item', this.options.three.item);
			},
			xfu() {
				/**
				 实训模块：（24个）
				 二楼：学生宿舍，校园警务室，校车安全，教学楼安全，书店， 网吧；
				 三楼：重点车辆安全，客运安全，食品加工小作坊，餐饮店厨房 ，便民超市，童装厂，出租屋，寄递安全；
				 四楼：防范邪教，反恐防暴，建筑工地，施工用电安全，生产车间，特种设备，燃气安全，危化企业，国家安全，生态治理，
				 */
				console.log('this.curriculum:-->', this.curriculum)
				for (let i in this.curriculum) {
					if (this.curriculum[i] === 'xsss') {
						this.options.two.item.push({
							value: "xsss",
							label: "学生宿舍"
						})
					} else if (this.curriculum[i] === 'xyjws') {
						this.options.two.item.push({
							value: "xyjws",
							label: "校园警务室"
						})
					} else if (this.curriculum[i] === 'xc') {
						this.options.two.item.push({
							value: "xc",
							label: "校车安全"
						})
					} else if (this.curriculum[i] === 'jxl') {
						this.options.two.item.push({
							value: "jxl",
							label: "教学楼安全"
						})
					} else if (this.curriculum[i] === 'sd') {
						this.options.two.item.push({
							value: "sd",
							label: "书店"
						})
					} else if (this.curriculum[i] === 'wb') {
						this.options.two.item.push({
							value: "wb",
							label: "网吧"
						})
					} else if (this.curriculum[i] === 'wc') {
						this.options.three.item.push({
							value: 'wc',
							label: '重点车辆安全'
						})
					} else if (this.curriculum[i] === 'kyz') {
						this.options.three.item.push({
							value: 'kyz',
							label: '客运车安全'
						})
					} else if (this.curriculum[i] === 'spxzf') {
						this.options.three.item.push({
							value: 'spxzf',
							label: '食品加工小作坊'
						})
					} else if (this.curriculum[i] === 'cydcf') {
						this.options.three.item.push({
							value: 'cydcf',
							label: '餐饮店厨房'
						})
					} else if (this.curriculum[i] === 'bld') {
						this.options.three.item.push({
							value: 'bld',
							label: '便民超市'
						})
					} else if (this.curriculum[i] === 'tzc') {
						this.options.three.item.push({
							value: 'tzc',
							label: '童装厂'
						})
					} else if (this.curriculum[i] === 'czw') {
						this.options.three.item.push({
							value: 'czw',
							label: '居住出租屋'
						})
					} else if (this.curriculum[i] === 'yjaq') {
						this.options.three.item.push({
							value: 'yjaq',
							label: '寄递安全'
						})
					} else if (this.curriculum[i] === 'xj') {
					 	this.options.four.item.push({
					 		value: 'xj',
					 		label: '防范邪教'
					 	})
					 } else if (this.curriculum[i] === 'fank') {
					 	this.options.four.item.push({
					 		value: 'fank',
					 		label: '反恐防暴'
					 	})
					 } else if (this.curriculum[i] === 'jzsgaq') {
						this.options.four.item.push({
							value: 'jzsgaq',
							label: '建筑工地安全'
						})
					}else if (this.curriculum[i] === 'dg') {
						this.options.four.item.push({
							value: 'dg',
							label: '施工用电安全'
						})
					} else if (this.curriculum[i] === 'aqsc') {
						this.options.four.item.push({
							value: 'aqsc',
							label: '生产车间'
						})
					} else if (this.curriculum[i] === 'tzsb') {
						this.options.four.item.push({
							value: 'tzsb',
							label: '特种设备'
						})
					} else if (this.curriculum[i] === 'rq') {
						this.options.four.item.push({
							value: 'rq',
							label: '燃气安全'
						})
					} else if (this.curriculum[i] === 'weih') {
					 	this.options.four.item.push({
					 		value: 'weih',
					 		label: '危化企业'
					 	})
					} else if (this.curriculum[i] === 'gjaq') {
						this.options.four.item.push({
							value: 'gjaq',
							label: '国家安全'
						})
					} else if (this.curriculum[i] === 'stzl') {
						this.options.four.item.push({
							value: 'stzl',
							label: '生态治理'
						})
					}
				}
			},
			FAuni() {
				localStorage.removeItem("userInfo");
				this.$router.push('/home')
			},

			// 接收数据
			receive() {
				var user = JSON.parse(localStorage.getItem("userInfo"))
				console.log(user);
				this.username = user.username
				this.number = user.number
				this.curriculum = user.curriculum
			},
			fSearch(e) {
				if (e) {
					return this.fraction.filter((value) => { //过滤数组元素
						return value.includes(e) // 如果包含字符返回true
					});
				}
			},

			// 选择
			async handleChange(item) {
				console.log(item.value);
				const xxhh = this.curriculum.includes(item.value) ? 1 : 0;
				if (xxhh === 1) {
					var xioH = []
					const label = item.label
					const {
						data: res
					} = await this.$http.get(`fractionFS/${this.number}`)
					console.log(res);
					res.forEach(item => {
						console.log(item.fraction, label);
						if (item.fraction && item.fraction.indexOf(label) != -1) {
							xioH.push(1)
						} else {
							xioH.push(2)
						}
					});
					console.log(xioH);
					if (xioH.indexOf(1) > -1) {
						alert(`以完成${label}考试，请勿重复考试！`)
					} else {
						this.$router.push({
							path: "/Practicaltraining",
							query: {
								number: this.number,
								Icurriculum: item.value,
							}
						});
					}
				} else {
					this.$message.error('您未预约该考项，请重新选择考试项!')
				}
			},


			// 数组模糊查询
			// fSearchone(e) {
			//     // console.log(e, this.fraction);
			//     if(e){
			//         return this.fraction.filter((value)=>{  //过滤数组元素
			//             return value.includes(e) //如果包含字符返回true
			//             // console.log(value.includes(e));
			//         });
			//     }
			// },
			RQfSearch(e) {
				if (e) {
					return this.fraction.filter((value) => { //过滤数组元素
						return value.includes(e) //如果包含字符返回true
					});
				}
			}

		}
	}
</script>


<style lang="less" scoped>
	.content {
		height: 100%;
	}

	// 引入swiper css
	.iconfont {
		font-size: 50px;
		color: #fff;
		padding-left: 16px;
	}

	.bgcimg {
		width: 100%;
	}

	.bgcimg img {
		width: 100%;
		height: 230px;
		padding-top: 50px;
	}

	.kists {
		font-size: 24px;
		padding-top: 5%;
	}

	.el-main {
		height: 80%;
		margin-top: 50px;
		position: relative;
	}

	.el-main p {
		color: #fff;
		font-size: 25px;
		text-align: right;
	}
	
	.el-main .tips, .el-main .el-button--primary {
		float: right;
	}
	.el-main .el-button--primary {
		font-size: 24px;
		margin-right: 50px;
	}

	.el-header {
		padding-top: 18px;
	}

	.el-header p {
		color: #fff;
		margin: 0 auto;
		font-size: 2em;
		font-weight: 600;
	}

	.el-header span {
		display: block;
	}

	.el-header .logoh1 {
		font-size: 0.9em;
		font-weight: 400;
		margin-left: 0.1875rem;
		margin-top: -0.25rem;
	}

	.el-header {
		//   margin: 1.25rem 0;
		margin-left: 8.75rem;
		display: flex;
		justify-content: space-between;
	}

	.Right {
		margin-right: 6.25rem;
		margin-top: -0.7rem;
	}

	.iconHome {
		font-size: 22px;
		color: #fff;
	}

	.bg-set {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		z-index: -1;
	}

	div {
		color: #000;
	}

	.timeTips {
		position: absolute;
		top: 1%;
		left: 50%;
		transform: translateX(-50%);
	}

	.Tips {
		color: #999;
		font-size: 45px;
		text-align: center;
		font-weight: 700;
		letter-spacing: 25px;
	}

	/deep/.el-select {
		width: 40%;
		position: absolute;
		right: 2%;
	}

	/deep/ .el-input__inner {
		height: 70px;
		line-height: 70px;
		font-size: 24px;
	}

	.bgiss {
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: -99;
	}

	/deep/ .el-select-dropdown__item {
		font-size: 25px;
		height: 59px;
		line-height: 59px;
	}

	.xiao {
		position: fixed;
		top: 16%;
		top: 30%; //平板专用
		bottom: 10%;
		width: 45%;
		right: 4%;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-content: flex-start;
		flex-direction: row;
		overflow-y: scroll;
	}

	.xiao .list_title {
		width: 100%;
		color: #fff;
	}
	
	.xiao .list_title p{
		font-size: 48px;
		font-weight: bold;
		text-align: center;
	}

	.xiao .list_title p:first-child {
		padding: 0;
		margin-top: 0;
	}

	.imgss {
		width: 20%;
	}

	.imgss img {
		width: 100%;
		height: 100%;
	}
</style>
